module.exports = __webpack_public_path__ + "img/pedagio_automatizado.60a96c56.png";